import kestrel1 from "../../images/case/kestrel1.jpg";
import kestrel2 from "../../images/case/kestrel2.jpg";
import kestrel3 from "../../images/case/kestrel3.jpg";
import kestrel4 from "../../images/case/kestrel4.jpg";
import kestrel5 from "../../images/case/kestrel5.jpg";
import kestrel6 from "../../images/case/kestrel6.jpg";
import kestrel7 from "../../images/case/kestrel7.jpg";
import kestrel8 from "../../images/case/kestrel8.jpg";
import kestrel9 from "../../images/case/kestrel9.jpg";
import kestrel10 from "../../images/case/kestrel10.jpg";
import kestrel11 from "../../images/case/kestrel11.jpg";
import kestrel12 from "../../images/case/kestrel12.jpg";

import formosan1 from "../../images/case/formosan-1.jpg";
import formosan2 from "../../images/case/formosan-2.jpg";
import formosan3 from "../../images/case/formosan-3.jpg";
import formosan4 from "../../images/case/formosan-4.jpg";
import formosan5 from "../../images/case/formosan-5.jpg";
import formosan6 from "../../images/case/formosan-6.jpg";
import formosan7 from "../../images/case/formosan-7.jpg";
import formosan8 from "../../images/case/formosan-8.jpg";
import formosan9 from "../../images/case/formosan-9.jpg";

import ruddy1 from "../../images/case/ruddy-1.jpg";
import ruddy2 from "../../images/case/ruddy-2.jpg";
import ruddy3 from "../../images/case/ruddy-3.jpg";
import ruddy4 from "../../images/case/ruddy-4.jpg";
import ruddy5 from "../../images/case/ruddy-5.jpg";
import ruddy6 from "../../images/case/ruddy-6.jpg";
import ruddy7 from "../../images/case/ruddy-7.jpg";

import case1Kv from "../../images/case/case1Kv.jpg";
import case2Kv from "../../images/case/case2Kv.jpg";
import case3Kv from "../../images/case/case3Kv.jpg";



const dataA = {
  t: case1Kv,
  ytId: 'PmTWQCILYas',
  title: {
    num: "01",
    text: "紅隼",
  },
  info: [
    {
      text: `
      湍急的河水、崎嶇的溪床，家鄉在對岸的山林裡，一切看似近若咫尺，卻萬般驚險、難以靠近。這次，能順利抵達嗎?
      `,
      img: kestrel1
    },
    {
      text: `
      在臺灣，每年有上千隻野生動物，因車禍、陷阱、中毒、盜獵等種種原因遭遇不幸；而在幅員遼闊的花東，更可能因送醫車程過長、醫療資源不足等問題，讓許多受傷的野生動物在還沒來得及救治就回天乏術。
      
      臺東池上野灣野生動物醫院正努力為花東的野生動物爭取更多活下去的機會，雖然沒有豐厚的資金、充足的人力，但有一群人在這裡懷抱熱情，努力不懈。他們每年救治上百隻受難的動物，經過獸醫的診治加上保育員的照顧、訓練，替受傷的野生動物們爭取重返山林的機會。
      `,
      img: kestrel2
    },
    {
      text: `
      這次，柯有倫來到了池上，為了送這些重要的乘客重返山林，他駕駛著有陸地巡航艦美稱的TOYOTA LAND CRUISER PRADO，準備展開最困難的三項任務。

      在野灣醫治完動物之後，柯有倫與PRADO將載著他們，深入山林與溪水峽谷，利用PRADO絕佳的越野性能，帶著野生動物回到更沒有人類打擾的荒野中。
      `,
      img: kestrel3
    },
    {
      text: `
      2020年9月7日，一隻紅隼在機場周圍被發現，因不明原因無法飛行，差點被車輾斃，飽受驚嚇，被好心民眾送到野灣動物醫院。

      「當時牠抵達醫院的時候，狀況虛弱，體重只有正常的一半，經過一連串檢查，我們判斷應該是營養與肌力不足，讓牠無法正常飛行。」保育員朝盛一邊小心翼翼掀開掩蓋籠子的布條，檢查紅隼的休息狀況；一邊解釋道。
      `,
      img: kestrel4
    },
    {
      text: `
      經過獸醫與保育員三個多月的治療、餵食、訓練，紅隼才又能重新飛翔。（圖為紅隼在大型訓練籠中，由自動相機捕捉下的畫面）
      `,
      img: kestrel5
    },
    {
      text: `
      野放當天，柯有倫、保育員們一行人駕車來到北絲鬮溪的深處上游，目標是越過河床，讓紅隼回到對岸的山林裡。

      面對廣闊的溪床與湍急的河水，大夥兒在車邊討論著待會過溪的狀況，由於連日降雨，水位上漲了不少，任務比想像中更艱難，這也是為什麼PRADO前來支援此次任務。      
      `,
      img: kestrel6
    },
    {
      text: `
      「慢點！慢點！」當PRADO駛入水中的同時，能夠明顯感受到車身被水流帶走的橫移，讓眾人捏了一把冷汗。

      「這個地方需要一鼓作氣，PRADO的底盤是出名的堅韌，還有絕佳的大扭力，沒問題的！」柯有倫堅定握著方向盤，安撫著說道。有的路段水位深及腰部，水流不時湧上沖擊引擎蓋，讓人有種被淹沒的錯覺。
      `,
      img: kestrel7
    },
    {
      text: `
      幸虧LAND CRUISER PRADO的純正越野設計，2021年式全新搭載2.8L 渦輪增壓柴油引擎，擁有最大51.0 Kg-m的強大扭力，搭配設定在高位置的頭燈與進氣壩，讓它得以通過困難的涉水地形，雖然氣氛緊張，但在駕馭的過程中，能夠完整的感受到PRADO優異的性能所帶來的駕馭樂趣。
      `,
      img: kestrel8
    },
    {
      text: `
      沿著溪床朝上游行駛近一小時，突破7、8處涉水路段，強勁的水流甚至將車牌沖斷，一度擔心這次必須要先撤退，不過最後PRADO帶領著大家，順利越過湍急溪水，抵達預定的野放地點，讓所有人都表示讚嘆，也鬆了一口氣。
      `,
      img: kestrel9
    },
    {
      text: `
      經過了三個多月的努力，終於來到了這一刻。

      緩慢打開籠子，紅隼面對自由廣闊的天空探了探頭，躊躇了幾秒後，瞬間，振翅朝遠方的藍天與山林飛去，原以為牠會直衝到消失不見，但牠在遠方空中盤旋了幾圈，似乎在與保育員不捨道謝，最後才成為黑點，隱沒在樹林間。
      `,
      img: kestrel10
    },
    {
      text: `
      面對這些日子以來的照顧，保育員們全程都望著天際，眼神遲遲不願離開紅隼離開的方向。

      「雖然不捨，這卻是最棒的結局，因為不是每隻野生動物都撐得到回家那天。可以成功野放牠們就是最棒的事情。」保育員這麼說著。
      `,
      img: kestrel11
    },
    {
      text: `
      第一趟任務圓滿結束了，大夥兒在河川旁用帶來的鍋爐煮食、休息，緩解前面緊張的情緒，再收拾回程。

      而柯有倫與PRADO的故事未完待續。
      `,
      img: kestrel12
    }
  ]
};
const dataB = {
  t: case2Kv,
  ytId: '5jg6sExPRC4',
  title: {
    num: "02",
    text: "白鼻心",
  },
  info: [
    {
      text: `第二次任務，柯有倫與TOYOTA LAND CRUISER PRADO 從溪谷返回山林，從ON-ROAD再回到OFF-ROAD。幼小的白鼻心極容易受到驚嚇，需要小心翼翼行駛著，PRADO能否提供最安穩的乘坐體驗，讓最重要的乘客順利回家？`,
      img: formosan1
    },
    {
      text: `
      數個月前，年幼的白鼻心遭人類飼養的土狗追逐而與母親失散，當時牠才剛斷乳換牙，無法獨自在野外生存，只能由野灣野生動物醫院代為照顧，直到牠成熟到足以應付野外生活。

      「牠剛到醫院時，令大家都滿擔心的，因為好像都不怎麼吃東西。」保育員朝盛邊準備著待會兒要用來移動白鼻心的籠子，邊憶起最初的情況。

      「畢竟剛從野外到人類環境吧！一開始很不適應，還被捉起來健康檢查，所以比較沒有安全感，食慾不太好。」獸醫師昀蓉則是整理著野放前最後健康檢查的設備，邊補充說明。
      `,
      img: formosan2
    },
    {
      text: `這幾個月來，雖然白鼻心剛開始對人類保持戒心，會有威嚇、小小攻擊保育員的動作，但持續照顧之後，牠慢慢進食、適應環境、增加活力，也越來越適應住院的生活。`,
      img: formosan3
    },
    {
      text: `從餵奶開始，再逐漸轉移到固體食物，如水果、小雞、老鼠等等，每天，保育員除了餵食、記錄健康狀態，還得進行讓白鼻心熟悉野生環境的訓練， 讓牠住進模擬野外環境的大型訓練籠之中，並放置一些野果，讓白鼻心習慣自己去找尋、取食。`,
      img: formosan4
    },
    {
      text: `12月3日這天，一切就緒，努力很久的白鼻心終於要回家了，待在野灣這麼多天，大家也對白鼻心萌生了情感，所有照顧過牠的保育員、獸醫師都希望能一同前往，送牠重返山林的家。`,
      img: formosan5
    },
    {
      text: `
      「我們這樣六個人坐得下嗎？」朝盛看著後座空間問道。

      「沒問題的，最後一排可以將座椅升上來，最多能坐七個人。來！上車吧！」柯有倫邊按著電動按扭，邊笑著調整座椅。
      
      LAND CRUISER PRADO有著七人座大空間，柯有倫、五名保育員與安置在籠子內的白鼻心，全部人坐滿也不會過於擁擠；平時如果只乘坐2-4人，最後排的椅背整排倒下，足夠放置充足的裝備與行李。
      
      `,
      img: formosan6
    },
    {
      text: `
      原本最令人擔心的是行駛過程中，越野車的晃動不適會讓白鼻心再次過於緊張，但沒想到PRADO的正統越野外表下，蘊藏著柔情的內在。

      雖為越野車，但PRADO行駛在一般道路與平緩山路時格外舒適，隔音與座椅可以比擬一般頂級休旅。標配TSS /PVM/ 7SRS氣囊與搭載KDSS動態懸吊控制系統以及AVS可變阻尼避震系統，不管何種道路與地形，給予駕駛最穩定安全的操控與反饋。
      
      「當ON-ROAD狀態，你不覺得自己開的是一台極致野性的越野車，整體感受是很平穩的，即使當作日常代步車也不覺得突兀；一旦切換到了OFF-ROAD，PRADO內斂的外表下，卻有藏不住的傲氣。」在彎過最後一道彎，車子停下，柯有倫為這幾次駕駛PRADO的感受詮釋出一個註腳。      
      `,
      img: formosan7
    },
    {
      text: `從平地深入山林，小小白鼻心一路情緒穩定，打開籠門後，他先是探了探頭，最後沒有回頭，隱沒樹叢間，順利地回家了。全部的人鬆了一口氣，開心地笑了。`,
      img: formosan8
    },
    {
      text: `
      「越野」的意義，除了體驗其中樂趣之外，正是帶我們跨越文明與荒野的界線，看到在都市叢林沒有想過的事情。

      這兩次任務，我們橫越河床溪谷、穿梭林間、看見大群虎頭蜂啃食山羊屍體、看紅隼與白鼻心從人類文明回到自然荒野的瞬間，那樣的衝擊與感動，如果從未跨越文明界線，可能是一輩子無法體會到的。
      
      了解自然環境、了解野生動物，意識到文明與自然可能帶著些微衝突，我們努力找尋平衡，並努力保護野生動物。
      
      也許，這就是「越野」的精神。
      `,
      img: formosan9
    }
  ]
};
const dataC = {
  t: case3Kv,
  ytId: '_xQ0o57NxAI',
  title: {
    num: "03",
    text: "赤翡翠",
  },
  info: [
    {
      text: `編號003的任務，是送赤翡翠回到幽靜山林。更顛簸的林道、更劇烈的晃動，再次展現TOYOTA LAND CRUISER PRADO的越野能力，柯有倫與野灣野生動物醫院的邂逅，會在什麼挑戰之下劃上句點呢？`,
      img: ruddy1
    },
    {
      text: `
      那天，接到民眾的通報，一位短暫來台灣的訪客遇上了意外，暫時無法離開。

      請善心人士送來野灣的，是一隻體格嬌小但毛色亮麗的赤翡翠，由於醫院當時還沒有X光設備，獸醫師僅能以觸診檢查，初步判斷沒有骨折，唯獨脖子卻有一個五元硬幣大小的撕裂傷，須儘快處理。
      
      這樣一個大小的撕裂傷對於赤翡翠嬌小的身軀來說，是非常嚴重的，於是緊急止血、進行手術縫合，才保住了牠的性命。往後的日子，為了避免傷口處皮膚過薄而讓內臟與肌肉乾掉，每天都要謹慎地清創與包紮傷口。起初，小傢伙甚至沒辦法自行取食，得用夾子塞一些小魚、小昆蟲餵他；兩週後，才開始可以放一些小魚在水盆裡，讓他自行取食。
      
      `,
      img: ruddy2
    },
    {
      text: `「第四週的時候，我們也開始試著讓牠進行模擬飛行訓練，但小型鳥類不適合在像白鼻心住的那種訓練籠裡，因為牠們容易緊張，常常橫衝直撞，如果撞上鐵籠可能再次傷害。所以我們在這裡搭建了一組小型帳篷，讓他在裡頭練習飛行，即使不幸衝撞了也沒事。」朝盛與柯有倫解釋道。`,
      img: ruddy3
    },
    {
      text: `
      而一個半月後的今天，是赤翡翠的大日子，小心翼翼地將赤翡翠放進移動籠，安置在PRADO的後座，柯有倫與保育員們開著PRADO深入山林，護送赤翡翠回到森林裡頭。

      由於受過較嚴重的傷，希望讓赤翡翠在深山一點的地方適應，避免遭受打擾，我們深入東部的部落深山，路途上經過好幾處顛簸的地形，讓車身大角度傾斜，但幸虧有智慧型越野顯示幕，車頭、車側、車尾全方位攝影鏡頭顯示車輛周圍影像，「底盤透視」功能更可以掌握越野的輪胎位置與狀況。
      `,
      img: ruddy4
    },
    {
      text: `
      這幾次任務下來，行駛著PRADO涉水、越野走過不同地形，在智慧型越野地形系統(Multi-Terrain Select)中，提供五種地形模式，搭配Crawl Control智慧型越野緩進系統，讓駕駛輕鬆應付各種險惡地形。
      
      在眾多輔助的配備之下，即使是越野初心者，也能在入門地形即刻感受到駕馭樂趣，更別說專業玩家對於這台擁有深厚歷史底蘊、堅韌品質與高妥善率的陸地巡航艦也愛不釋手。
      
      可以深刻感受 LAND CRUISER PRADO不是需要征服的生硬野獸，它低調內斂，保富內涵，是個在各種險境都默默支持每趟冒險的柔情硬漢。
      `,
      img: ruddy5
    },
    {
      text: `
      最後，順利克服地形，我們也安全抵達野放地點。特別的是，釋放赤翡翠那一刻，牠飛出停在我們周遭的樹梢上，回望著，遲遲不願意離開，時不時發出悠揚叫聲。

      「就當作你在說謝謝囉！」柯有倫笑著對赤翡翠揮手。
      
      一路跟著野灣忙進忙出好幾天，最後終於野放三隻動物回家，草創的人力與資源匱乏，讓保育員與獸醫師們時常吃不消。 「但是每次打開籠門的感動，就足夠我們再繼續努力下去。」朝盛這麼說著。
      `,
      img: ruddy6
    },
    {
      text: `
      與赤翡翠告別的同時，我們也思考著，人類與動物棲息地高度重疊之下，我們還能做些什麼？

      柯有倫、PRADO與野生動物的故事，暫時劃下句點了，但人類與大自然的關係不會就此結束。
      
      野灣野生動物醫院努力延續動物的生命，PRADO也奉獻一己之力，無畏困境，跨越荒野，展現真正的越野精神。
      
      下次，換你寫下與LAND CRUISER PRADO的故事。
      `,
      img: ruddy7
    }
  ]
};

export {dataA, dataB, dataC};